<ng-container>
	<mat-card [ngStyle]="_visible()" class="video-table panel" >
		<!-- <div [ngClass]="{'active-panel-tab': _active(), 'panel-tab': !_active()}" fxLayout="row">
			<div fxFlex="fit-content" fxLayoutAlign="start">
				<button (click)="_visibleChange(false);" *ngIf="!locked" class="close-button" color="primary" mat-icon-button>
					<mat-icon class="close-icon">clear</mat-icon>
				</button>
			</div>
			<div class="panel-title" fxFlex style="margin:0">
				<button (click)="speed(-0.1)" mat-mini-fab style="background-color: #fdfdfd;margin: 4px;">
					<mat-icon color="warn" style="font-weight: 900;">arrow_drop_up</mat-icon>
				</button>
				{{rate | fixed:2 }}倍
				<button (click)="speed(0.1)" mat-mini-fab style="background-color: #fdfdfd;margin: 4px;">
					<mat-icon color="warn" style="font-weight: 900;">arrow_drop_down</mat-icon>
				</button>
			</div>
		</div> -->
		<!-- <div fxLayout="row" fxLayoutAlign="center">
			<div fxFlex>
				<button (click)="top()" class="icon-arrow" mat-icon-button>
					<mat-icon class="icon" color="primary">skip_previous</mat-icon>
				</button>
				<button (click)="play()" class="icon-arrow" mat-icon-button>
					<mat-icon class="icon" color="primary">play_arrow</mat-icon>
				</button>
				<button (click)="pause()" class="icon-arrow" mat-icon-button>
					<mat-icon class="icon" color="warn">pause</mat-icon>
				</button>
			</div>
		</div> -->
		<!-- <div fxLayout="row" fxLayoutAlign="center" class="panel-title">
			<div style="margin:0">
				<button (click)="speed(-0.1)" mat-mini-fab style="background-color: #fdfdfd;margin: 4px;">
					<mat-icon color="warn" style="font-weight: 900;">expand_more</mat-icon>
				</button>
				{{rate | fixed:2}}倍
				<button (click)="speed(0.1)" mat-mini-fab style="background-color: #fdfdfd;margin: 4px;">
					<mat-icon color="warn" style="font-weight: 900;">expand_less</mat-icon>
				</button>
			</div>
		</div> -->
		<mat-card-content class="panel-content">
			<div *ngIf="locked" cdkDragHandle></div>
			<div *ngIf="videos; else noData">
				<div *ngIf="videos.length > 0; else noData" fxLayout="column" fxLayoutAlign="start">
					<div *ngFor="let video of selected()">
						<aigia-video [active]="_active()" [size]="size" [src]="video"></aigia-video>
					</div>
				</div>
			</div>
			<ng-template #noData>
				<mat-card>
					<mat-card-header>
						<mat-card-title style="font-weight:900;color:#fdfdfd;">No data<br/>selected.</mat-card-title>
					</mat-card-header>
					<mat-card-content>
					</mat-card-content>
				</mat-card>
			</ng-template>
		</mat-card-content>
	</mat-card>
</ng-container>
